import { TSESTree } from '@typescript-eslint/types';

export class FunctionsFilterModel {
  constructor(public originalString = '', public functionTree: TSESTree.Program | null = null) {}
}
